// Popups
import PortalContainer from "@widget/popups/PortalContainer";
import Tooltip from "@widget/popups/Tooltip";
import InfoButton from "@widget/popups/InfoButton";
import DropDownButton from "@widget/popups/DropDownButton";
import Popover from "@widget/popups/Popover";
import Modal from "@widget/popups/Modal";
import ModalWizard from "@widget/forms/wizard/ModalWizard";
import FilterPanel from "@widget/popups/FilterPanel";
import { Dropdown } from "@widget/popups/Dropdown";
// Forms
import { Wizard } from "@widget/forms/wizard/Wizard";
import FormField from "@widget/forms/inputs/FormField";
import FormFeedback from "@widget/forms/inputs/FormFeedback";
import Label from "@widget/forms/inputs/Label";
import Input from "@widget/forms/inputs/Input";
import PasswordInput from "@widget/forms/inputs/PasswordInput";
import Checkbox from "@widget/forms/inputs/Checkbox";
import Select from "@widget/forms/inputs/Select";
import MultiSelect from "@widget/forms/inputs/MultiSelect";
import DynamicSelect from "@widget/forms/inputs/DynamicSelect";
import CascadingSelect from "@widget/forms/inputs/CascadingSelect";
import AppRoleInput from "@widget/forms/inputs/AppRoleInput";
import DatePicker from "@widget/forms/inputs/DateTimePicker/DatePicker";
import DateRangePicker from "@widget/forms/inputs/DateTimePicker/DateRangePicker";
import TimePicker from "@widget/forms/inputs/DateTimePicker/TimePicker";
import TimeRangePicker from "@widget/forms/inputs/DateTimePicker/TimeRangePicker";
import DateTimePicker from "@widget/forms/inputs/DateTimePicker/DateTimePicker";
import SearchBox from "@widget/forms/inputs/SearchBox";
import CalendarComponent from "@widget/forms/inputs/DateTimePicker/CalendarComponent";
import ColorPicker from "@widget/forms/inputs/ColorPicker/ColorPicker";
import ColorPallet from "@widget/forms/inputs/ColorPicker/ColorPallet";
import AutoCompleteInput from "@widget/forms/inputs/AutoComplete";
import TextArea from "@widget/forms/inputs/TextArea";
import FileInput from "@widget/forms/inputs/FileInput/FileInput";
import IconPicker from "@widget/forms/inputs/IconPicker/IconPicker";
import ToggleFilter from "@widget/forms/inputs/ToggleFilter";
import PillInput, { Pill } from "@widget/forms/inputs/PillInput/PillInput";
import CodeEditor from "@widget/forms/inputs/CodeEditor/CodeEditor";
import MarkdownPreview from "@widget/forms/inputs/MarkdownPreview/MarkdownPreview";
import MarkdownEditor from "@widget/forms/inputs/MarkdownEditor/MarkdownEditor";
import { applyFormatters, extractAndFormatValue, hasPlaceholders, parsePlaceholders } from "@widget/forms/inputs/PillInput/pill-input-utils";
import TagInput from "@widget/forms/inputs/TagInput";
import InfoCardGroupInput from "@widget/forms/inputs/InfoCardGroupInput";
import { HelpPopover } from "@widget/other/HelpPopover";
import { ConfigurationView } from "@widget/forms/ConfigurationView/ConfigurationView";
import { ConfigurationViewHeader } from "@widget/forms/ConfigurationView/ConfigurationViewHeader";
import { ConfigurationViewContent } from "@widget/forms/ConfigurationView/ConfigurationViewContent";
import { SimpleConfigurationTable } from "@widget/forms/SimpleConfigurationTable/SimpleConfigurationTable";
import { DataEntryForm, DataEntryField, DataEntrySection, SlideInForm } from "@widget/forms/DataEntryForm";
import DynamicForm from "@widget/forms/DynamicForm/DynamicForm";
// Buttons
import Button from "@widget/buttons/Button";
import AsyncButton from "@widget/buttons/AsyncButton";
import IconButton from "@widget/buttons/IconButton";
import ConfirmButton from "@widget/buttons/ConfirmButton";
import ButtonGroup from "@widget/buttons/ButtonGroup";
import ButtonComponent from "@widget/buttons/ButtonComponent";
// Lists
import DataList from "@widget/list/DataList";
import DataTable from "@widget/list/DataTable";
import DataGrid from "@widget/list/DataGrid";
import { SortableList } from "@widget/list/SortableList";
import HorizontalScrollList from "@widget/list/HorizontalScrollList";
import ItemCard from "@widget/list/ItemCard";
import ItemListCard from "@widget/list/ItemListCard";
import InfoCard from "@widget/list/InfoCard";
import UserInfoCard from "@widget/list/UserInfoCard";
import InfoCardGroup from "@widget/list/InfoCardGroup";
import TabComponent from "@widget/list/Tabs/TabComponent";
import TableComponent from "@widget/list/Tables/TableComponent";
import PaginationComponent from "@widget/list/Pagination/PaginationComponent";
import CRUDComponent from "@widget/list/CRUD/CRUDComponent";
import TreeView from "@widget/list/TreeView/TreeView";
import TreeViewCompare from "@widget/list/TreeView/TreeViewCompare";
import TreeViewSelectInput from "@widget/list/TreeView/TreeViewSelect";
import { generateTreeNodesFromFlatList, flattenTreeNodesToOriginalFlatList, findTreeNodeById, findTreeNodeByIdSync, findTreeNodeByPath, processTreeNode, processAllTreeNodes } from "@widget/list/TreeView/treeview-utils";
import { ObjectSearchComponent } from "@widget/list/Tables/object-search/ObjectSearchComponent";
import { ObjectDetailsPanel } from "@widget/list/Tables/object-search/ObjectDetailsPanel";
import { ObjectInfoCard } from "@widget/list/Tables/object-search/ObjectInfoCardComponent";
import { ObjectDetailsPanelHeader } from "@widget/list/Tables/object-search/ObjectDetailsPanelHeader";
import { FilterView, isSimpleFilter, getFilterCount, cleanFilters, hasFilters } from "@widget/list/Tables/object-search/FilterView";
import ActionsListComponent from "@widget/list/Tables/Common/ActionListComponent";
// Charts
import PieChartComponent from "@widget/charts/PieChart";
import TrendChartComponent from "@widget/charts/TrendChart";
import RadialGauge from "@widget/charts/RadialGauge";
// Map
import MapComponent from "@widget/map/MapComponent";
// Loaders
import { Loading, LoadingSpinner, DefaultLoader, BarChartLoader, DonutChartLoader, GaugeLoader, HeatmapChartLoader, MapTileLoader, SkeletonLoader, LoadingFeedback } from "@widget/loaders";
// Other widgets
import TitleBar from "@widget/other/TitleBar";
import LinkWidgetContainer from "@widget/other/LinkWidgetContainer";
import LinkButtonWidget from "@widget/other/LinkButtonWidget";
import SampleDataLabel from "@widget/other/SampleDataLabel";
import ProfileImage from "@widget/other/ProfileImage";
import WidgetWrapper from "@widget/other/WidgetWrapper";
import { Collapse } from "@widget/other/Collapse";
import Chip from "@widget/other/Chip";
import DropdownIndicator from "@widget/other/DropdownIndicator";
import { Breadcrumb } from "@widget/other/Breadcrum";
import { AnalyticsCard } from "@widget/other/AnalyticsCard";
import { SlideInPanel } from "@widget/other/SlideInPanel";
// QR Code
import { QRCodeComponent } from "@widget/qr-code/QRCode";
// Icons
import Icon from "@icon/Icon";
import { FontAwesomeIconWrapper } from "@icon/fontawesome/FontAwesomeIconWrapper";
import { useIsFAIconReady } from "@icon/fontawesome/useIsFAIconReady";
import { PHIconWrapper } from "@icon/phosphor/PHIconWrapper";
import { useIsPHIconReady } from "@icon/phosphor/useIsPHIconReady";
import { parseIcon, hasIcon, isPhosphorIcon, isImageUrl, getPhosphorIcon } from "@icon/utils";
// Hooks
import useToast from "@notifications/Toast/useToast";
import useAlert from "@notifications/Alerts/useAlerts";
import useLoadingFeedback from "@notifications/LoadingFeedback/useLoadingFeedback";
import useDebounce from "@hooks/useDebounce";
import useFields from "@hooks/useFields";
import useResizeEffect from "@hooks/useResizeEffect";
import useUpdateWidgetProps from "@hooks/useUpdateWidgetProps";
import useEffectWithPolling from "@hooks/useEffectWithPolling";
import useHasChanged from "@hooks/useHasChanged";
import useCounter from "@hooks/useCounter";
import useWidgets from "@hooks/useWidgets";
import { useFormatters } from "@hooks/useFormatters";
import { useExportData } from "@hooks/useExportData";
import { useSearchParams, getSearchParamsFromURL, useRouterContext } from "@hooks/useRouteHandlers";
// Realtime
import { useMessageBus, publishMessage } from "@realtime/messagebus/useMessageBus";
import { eventDispatcher, useEventSubscriber, useMultiEventSubscriber } from "@realtime/eventbus/useEventBus";
// Core
import UserProfile from "@core/layout/components/UserProfile";
import { useUXPContext } from "@core/context/useUXPContext";
import { executeConfig, useExecuteRequest, useExecuteRequestCallback } from "@core/context/useExecuteRequest";
import { useLogout } from "@core/services/useLogout";
import { SafeLink } from "@core/route-context/RouteContext";
import { usePluggableView } from "@core/pages/pluggable-view/usePluggableView";
import PluggableViewConfig from "@core/pages/page-editor/PluggableViewConfig";
import { useTabInjection } from "@core/pages/injected-tabs/useTabInjection";
import { registerTabInjection } from "@core/pages/injected-tabs/tabInjectionRegistry";
import ComponentRenderer from "@helper/ComponentRenderer/ComponentRenderer";
import WidgetDrawer from "@core/dashboard/widget-drawer/WidgetDrawer";
import { EmbeddedDashboard } from "@core/dashboard/embedded-dashboard/EmbeddedDashboard";
import Dashboard from "@core/dashboard/Dashboard";
import WidgetPanel from "@core/dashboard/panel-widget/WidgetPanel";
import DiagnosticWidget from "@core/dashboard/diagnostic-widget/DiagnosticWidget";
import FloatingActions from "@core/floating-actions/FloatingActions";
import { registerFloatingActionSection, unregisterFloatingActionSection } from "@core/floating-actions/floatingActionsRegistry";
import DashboardConfigPanel from "@core/dashboard/configurations/DashboardConfigPanel";
// Helpers
import useDeleteAction from "@helper/DeleteAction/useDeleteAction";
import DeleteAction from "@helper/DeleteAction/DeleteAction";
import NotificationBlock from "@helper/NotificationBlock";
import { useAddOns } from "@helper/AddOn/useAddOns";
import { BuyOnSpaceworxButton, SpaceworxDescriptionTag } from "@helper/BuyOnSpaceworx";
import Transition from "@helper/transition/Transition";
// Localisation
import LocalizationForm from "@localisation/LocalisationForm";
import LocalizationFormModal from "@localisation/LocalisationFormModal";
import { getRegisterMessages } from "@localisation/localizationUtils";
import { saveLocalizations } from "@core/services/services";
// Theme
import ThemeChanger from "@theme/ThemeChanger";
import { ThemeType } from '@types';
import { defaultThemes, defaultLightTheme, defaultDarkTheme, defaultGlassDarkTheme, defaultGlassLightTheme, getColorGroups, getDefaultThemes, getDefaultThemeNames } from "@theme/themeUtils";
// Utilities
import { copyToClipboard, debounce, generateScriptPathFromModuleId, lookupComponent, normalizeModuleScriptUrl, generateUUID, getFontAwesomeIcon, getModuleIdFromScriptPath, getModuleIdFromWidget, getRelativeDateLabel, getUrlFriendlyString, hasValue, isFontawesomeIcon, isRelativeDate, loadAllScriptsByModuleId, loadScriptFile, loadScriptFileAsync, normalizeComponentId, parseRelativeDate, simpleHash, textSearch, toBool, toDate, toJSON, toNum, toPlural, toSingular, toStr, trimLeadingSlash, trimSlash, trimTrailingSlash } from "@utils";
import { DIAGNOSTIC_WIDGET_ID, WIDGET_PANEL_ID } from "@core/dashboard/dashboardUtils";
window.UXPComponents = {
    // Popups
    PortalContainer,
    Tooltip,
    InfoButton,
    DropDownButton,
    Popover,
    Modal,
    ModalWizard,
    FilterPanel,
    Dropdown,
    // Forms
    Wizard,
    FormField,
    FormFeedback,
    Label,
    Input,
    PasswordInput,
    Checkbox,
    Select,
    MultiSelect,
    DynamicSelect,
    CascadingSelect,
    AppRoleInput,
    DatePicker,
    DateRangePicker,
    TimePicker,
    TimeRangePicker,
    DateTimePicker,
    SearchBox,
    CalendarComponent,
    ColorPicker,
    ColorPallet,
    AutoCompleteInput,
    TextArea,
    FileInput,
    IconPicker,
    ToggleFilter,
    PillInput,
    Pill,
    CodeEditor,
    MarkdownPreview,
    MarkdownEditor,
    TagInput,
    parsePlaceholders,
    hasPlaceholders,
    extractAndFormatValue,
    applyFormatters,
    InfoCardGroupInput,
    HelpPopover,
    ConfigurationView,
    ConfigurationViewHeader,
    ConfigurationViewContent,
    SimpleConfigurationTable,
    DataEntryForm,
    DataEntryField,
    DataEntrySection,
    SlideInForm,
    DynamicForm,
    // Buttons
    Button,
    AsyncButton,
    IconButton,
    ConfirmButton,
    LinkButtonWidget,
    ButtonGroup,
    ButtonComponent,
    // Lists
    DataList,
    DataTable,
    DataGrid,
    SortableList,
    HorizontalScrollList,
    ItemCard,
    ItemListCard,
    InfoCard,
    UserInfoCard,
    InfoCardGroup,
    TabComponent,
    TableComponent,
    PaginationComponent,
    CRUDComponent,
    TreeView,
    TreeViewCompare,
    TreeViewSelectInput,
    generateTreeNodesFromFlatList,
    flattenTreeNodesToOriginalFlatList,
    findTreeNodeById,
    findTreeNodeByIdSync,
    findTreeNodeByPath,
    processTreeNode,
    processAllTreeNodes,
    ObjectSearchComponent,
    ObjectDetailsPanel,
    ObjectInfoCard,
    ObjectDetailsPanelHeader,
    FilterView,
    isSimpleFilter,
    getFilterCount,
    cleanFilters,
    hasFilters,
    ActionsListComponent,
    // Charts
    PieChartComponent,
    TrendChartComponent,
    RadialGauge,
    // Map
    MapComponent,
    // Loaders
    Loading,
    LoadingSpinner,
    DefaultLoader,
    BarChartLoader,
    DonutChartLoader,
    GaugeLoader,
    HeatmapChartLoader,
    MapTileLoader,
    SkeletonLoader,
    LoadingFeedback,
    // Other widgets
    TitleBar,
    LinkWidgetContainer,
    SampleDataLabel,
    ProfileImage,
    WidgetWrapper,
    Collapse,
    Chip,
    DropdownIndicator,
    Breadcrumb,
    AnalyticsCard,
    SlideInPanel,
    QRCodeComponent,
    // Icons
    Icon,
    FontAwesomeIconWrapper,
    useIsFAIconReady,
    PHIconWrapper,
    useIsPHIconReady,
    parseIcon,
    hasIcon,
    isPhosphorIcon,
    isImageUrl,
    getPhosphorIcon,
    isFontawesomeIcon,
    getFontAwesomeIcon,
    // Hooks
    useToast,
    useAlert,
    useLoadingFeedback,
    useDeleteAction,
    DeleteAction,
    useDebounce,
    useFields,
    useResizeEffect,
    useUpdateWidgetProps,
    useEffectWithPolling,
    useEventSubscriber,
    useMultiEventSubscriber,
    eventDispatcher,
    useHasChanged,
    useAddOns,
    useCounter,
    useWidgets,
    useFormatters,
    useUXPContext,
    useExecuteRequest,
    useExecuteRequestCallback,
    executeConfig,
    useLogout,
    useExportData,
    useMessageBus,
    publishMessage,
    useSearchParams,
    getSearchParamsFromURL,
    useRouterContext,
    usePluggableView,
    PluggableViewConfig,
    useTabInjection,
    registerTabInjection,
    // Core
    UserProfile,
    SafeLink,
    ComponentRenderer,
    WidgetDrawer,
    EmbeddedDashboard,
    Dashboard,
    WidgetPanel,
    DiagnosticWidget,
    FloatingActions,
    registerFloatingActionSection,
    unregisterFloatingActionSection,
    DashboardConfigPanel,
    // Helpers
    NotificationBlock,
    BuyOnSpaceworxButton,
    SpaceworxDescriptionTag,
    Transition,
    // Localisation
    LocalizationForm,
    LocalizationFormModal,
    getRegisterMessages,
    saveLocalizations,
    // Theme
    ThemeChanger,
    ThemeType,
    defaultThemes,
    defaultLightTheme,
    defaultDarkTheme,
    defaultGlassDarkTheme,
    defaultGlassLightTheme,
    getColorGroups,
    getDefaultThemes,
    getDefaultThemeNames,
    // Utilities
    hasValue,
    toJSON,
    toStr,
    toNum,
    toBool,
    toDate,
    toSingular,
    toPlural,
    textSearch,
    trimSlash,
    trimTrailingSlash,
    trimLeadingSlash,
    getUrlFriendlyString,
    parseRelativeDate,
    isRelativeDate,
    getRelativeDateLabel,
    getModuleIdFromWidget,
    getModuleIdFromScriptPath,
    generateScriptPathFromModuleId,
    normalizeModuleScriptUrl,
    loadScriptFile,
    loadScriptFileAsync,
    loadAllScriptsByModuleId,
    simpleHash,
    generateUUID,
    copyToClipboard,
    normalizeComponentId,
    lookupComponent,
    debounce,
};
// ── Built-in standard widgets ──────────────────────────────────────────────
// These are shipped with UXP Core and available on every dashboard without
// any additional bundles. Registered directly via registerComponent so they
// bypass the adapter layer and are not shown in marketplace listings.
window.registerComponent({
    id: WIDGET_PANEL_ID,
    name: 'Widget Panel',
    description: 'A nested dashboard panel that embeds a full grid of widgets inside another widget. Use it to create composite layouts, tabs-within-dashboards, or multi-column arrangements within a single dashboard cell.',
    component: WidgetPanel,
    modes: ['widget'],
    tags: ['uxp-core', 'standard', 'layout', 'dashboard'],
    vendor: 'UXP Core',
    configs: {
        props: [
            {
                name: 'orientation',
                label: 'Orientation',
                type: 'select',
                value: 'vertical',
                options: [
                    { label: 'Vertical', value: 'vertical' },
                    { label: 'Horizontal', value: 'horizontal' }
                ]
            },
            {
                name: 'columns',
                label: 'Columns',
                type: 'number',
                value: 30,
                show: (data) => data.orientation === 'vertical'
            },
            {
                name: 'rows',
                label: 'Rows',
                type: 'number',
                value: 20,
                show: (data) => data.orientation === 'horizontal'
            },
        ]
    },
    defaultProps: {
        columns: 30,
        orientation: 'vertical',
        rows: 20
    }
});
window.registerComponent({
    id: DIAGNOSTIC_WIDGET_ID,
    name: 'Diagnostic',
    description: 'A standard debugging widget that renders all props and URL search params it receives in table form. Drop it on any dashboard or view to inspect what data is being passed — useful for development and troubleshooting.',
    component: DiagnosticWidget,
    modes: ['widget'],
    tags: ['uxp-core', 'standard', 'diagnostic', 'debug'],
    vendor: 'UXP Core',
    configs: {
        layout: { w: 20, h: 14, minW: 8, minH: 6 }
    }
});
